// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2pLch","text":"SelectPayment_text__1lg2h","title":"SelectPayment_title__2fofh","btn":"SelectPayment_btn__2zi8a"};